// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomFacebook2 = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '16',
      height: '16',
      viewBox: '0 0 16 16',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14.6693 10.7934C14.6693 13.22 13.2226 14.6667 10.7959 14.6667H10.0026C9.63594 14.6667 9.33594 14.3667 9.33594 14V10.1534C9.33594 9.97338 9.4826 9.82005 9.6626 9.82005L10.8359 9.80005C10.9293 9.79338 11.0093 9.72672 11.0293 9.63338L11.2626 8.36005C11.2826 8.24005 11.1893 8.12671 11.0626 8.12671L9.6426 8.14671C9.45593 8.14671 9.30928 8.00005 9.30261 7.82005L9.27594 6.18671C9.27594 6.08004 9.3626 5.98671 9.47593 5.98671L11.0759 5.96004C11.1893 5.96004 11.2759 5.87338 11.2759 5.76005L11.2493 4.16003C11.2493 4.0467 11.1626 3.96004 11.0493 3.96004L9.24927 3.98671C8.1426 4.00671 7.26261 4.91337 7.28261 6.02004L7.31594 7.85337C7.32261 8.04004 7.17594 8.18671 6.98928 8.19338L6.18927 8.20671C6.07594 8.20671 5.98928 8.29336 5.98928 8.4067L6.00928 9.67338C6.00928 9.78671 6.09594 9.87337 6.20927 9.87337L7.00928 9.86005C7.19594 9.86005 7.3426 10.0067 7.34926 10.1867L7.40926 13.9867C7.41593 14.36 7.11593 14.6667 6.74259 14.6667H5.20927C2.7826 14.6667 1.33594 13.22 1.33594 10.7867V5.20671C1.33594 2.78004 2.7826 1.33337 5.20927 1.33337H10.7959C13.2226 1.33337 14.6693 2.78004 14.6693 5.20671V10.7934V10.7934Z',
      fill: 'currentColor',
    }),
  );

export { IconCustomFacebook2 };
